<template>
  <v-card class="pa-4">
    <p class="mb-2">
      <b>Numer:</b> {{ request.reference }}
    </p>
    <p class="mb-2">
      <b>Cel:</b> {{ request.purpose }}
    </p>
    <p class="mb-2">
      <b>Departament:</b> {{ request.department }}
    </p>
    <p class="mb-2">
      <b>Termin:</b> {{ request.deadline }}
    </p>
    <p class="mb-0">
      <b>Ścieżka KIW:</b> {{ request.kiwNumberAssignment ? 'tak' : 'nie' }}
    </p>
  </v-card>
</template>

<script>
export default {
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
};
</script>
